
import { Typography, Button } from "../../components"
import "./styles.css";

export default function Ervaringen(props) {
    return (
        <div className='container'>
            <Typography type='h1' style={{ color: 'var(--trust)', fontSize: '2.2em' }}>Ervaringen met NOLIA BabyFeeding</Typography>
            <div className="button-container">
                <Button 
                    target='_blank' 
                    href={'https://www.babyfeeding.nl/media/general/ervaringen/document/digital.pdf'} 
                    text={`Lees hier de ervaringen van ouders en zorgprofessionals met NOLIA BabyFeeding`}
                />  
            </div>
        </div>
    )
}
